import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { DumboProps as Props } from '../types';
import VotableAnswers from './VotableAnswers';
import VotedAnswers from './VotedAnswers';
import Timestamp from '../../../Timestamp';
import s from './Poll.scss';

const MAX_QUESTION_LENGTH = 55;

const Poll: React.FC<Props> = ({
  deviation: { poll },
  width,
  height,
  className,
  'aria-hidden': ariaHidden,
}) => {
  if (!poll) {
    return null;
  }

  const questionTruncated =
    poll.question && poll.question.length > MAX_QUESTION_LENGTH
      ? `${poll.question.slice(0, MAX_QUESTION_LENGTH)}...`
      : poll.question;

  return (
    <Section
      style={{ width, height }}
      className={classnames(className, s['root'])}
      aria-hidden={ariaHidden}
    >
      <Heading className={s['question']}>{questionTruncated}</Heading>
      <div className={s['info']}>
        <span className={s['date']}>
          <Timestamp timestamp={poll.ts} />
        </span>
        &nbsp; | &nbsp;
        <span className={s['vote-count']}>{poll.votes} votes</span>
      </div>
      {poll.hasVoted ? <VotedAnswers poll={poll} /> : <VotableAnswers poll={poll} />}
    </Section>
  );
};

export default Poll;
